import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  wrapper: {
    mb: '2',
    bgGradient: 'linear(to-b, alpha.300, alpha.500)',
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
    border: 'node',
    borderRadius: 'md',
    flexDirection: 'column',
    py: '2',
  },
  headerWrapper: {
    px: '3',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'heading',
    color: 'white',
  },
  headerCountText: {
    ml: '1',
    fontSize: '2xs',
    fontWeight: 'semibold',
    color: 'white',
  },
  headerExpandButton: {
    variant: 'unstyled',
    ml: 'auto',
    mr: '1',
    color: 'white',
    boxSize: '7',
    transform: 'rotate(180deg)',
  },
  toggleIcon: {
    boxSize: '4',
  },
  betsContainer: {
    flexDirection: 'column',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'alpha.700',
    ml: '1',
  },
  divider: {
    borderWidth: 'px',
    opacity: '1',
    borderColor: 'blackAlpha.400',
    mt: '1.5',
  },
  betRow: {
    py: '2',
    px: '2',
    gap: '2',
    bg: 'blackAlpha.300',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: 'base',
    mb: '1',
    _last: {
      mb: '0',
    },
  },
  betRowDivider: {
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: 'base',
    mb: '1',
    p: '2',
    _last: {
      mb: '0',
    },
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  categoryIcon: {
    color: 'beta.300',
    boxSize: '6',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    px: '3',
    border: 'none',
    boxShadow: 'none',
  },
  groupTitleText: {
    fontFamily: 'heading',
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'normal',
  },
  runnerText: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'white',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'beta.300',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  potentialWinningsText: {
    color: 'beta.300',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  subtitleText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
  },
  exoticsPositionText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
    w: 9,
  },
  viewMoreButton: {
    variant: 'secondary',
    alignItems: 'center',
    justifyContent: 'center',
    mb: -2,
    borderTopRadius: 'none',
    height: 8,
    _focus: {
      borderTopRadius: 'none',
    },
  },
  viewMoreButtonText: {
    fontWeight: 'bold',
    fontSize: 'sm',
    textTransform: 'uppercase',
    lineHeight: 'normal',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'normal',
    color: 'white',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    color: 'white',
  },
  flexiStakeValueText: {
    color: 'white',
    fontWeight: 'bold',
  },
};
